/* TrueSanity lux collection page (sections/ts-lux-collection.liquid) */
(function () {
  'use strict';
  var root = document.querySelector('.tsl');
  if (!root || root.__tsl) return;
  root.__tsl = true;

  var grid = root.querySelector('[data-tsl-grid]');
  var countEl = root.querySelector('[data-tsl-count]');
  var totalText = countEl ? countEl.textContent : '';

  /* ---------- collection intro: tidy the collection's own text (same words, nicer reading) ----------
     Lines pasted into the collection text often arrive as separate paragraphs that break mid-sentence;
     join a paragraph to the next one when it does not end a sentence. Long intros get a Read more. */
  (function tidyIntro() {
    var own = root.querySelector('.tsl-intro__own');
    if (!own) return;
    var box = own.querySelector('.metafield-rich_text_field') || own;
    var ps = Array.prototype.slice.call(box.querySelectorAll(':scope > p'));
    for (var i = ps.length - 1; i > 0; i--) {
      var prev = ps[i - 1], cur = ps[i];
      var t = (prev.textContent || '').replace(/\s+$/, '');
      if (t && !/[.!?:;\u2026"\u201d')\]]$/.test(t) && cur.textContent.trim()) {
        prev.appendChild(document.createTextNode(' '));
        while (cur.firstChild) prev.appendChild(cur.firstChild);
        cur.remove();
      }
    }
    // wrap everything after the H1 so long text can fold
    var h1 = box.querySelector('h1');
    var body = document.createElement('div'); body.className = 'tsl-intro__body';
    var n = h1 ? h1.nextSibling : box.firstChild;
    while (n) { var nx = n.nextSibling; body.appendChild(n); n = nx; }
    box.appendChild(body);
    own.classList.add('is-clamped');
    if (body.scrollHeight <= body.clientHeight + 4 || body.textContent.length < 160) { own.classList.remove('is-clamped'); }
    else {
      var more = document.createElement('button'); more.type = 'button'; more.className = 'tsl-intro__more'; more.textContent = 'Read more';
      more.setAttribute('aria-expanded', 'false');
      more.addEventListener('click', function () {
        var open = own.classList.toggle('is-clamped') === false;
        more.textContent = open ? 'Read less' : 'Read more';
        more.setAttribute('aria-expanded', String(open));
      });
      own.appendChild(more);
    }
  })();

  /* ---------- delivery: which pieces arrive in time ----------
     Same inputs and the same arithmetic as the product page's delivery date (snippets/ts2-delivery-date.liquid),
     US shipping. A tile only counts as "in time" when the LATEST date the product page would show is in time, so
     the collection page never promises more than the product page.
       inputs (per tile, the variant the product page opens on): stock count, ships-in days in stock (M),
       ships-in days made to order (L), price in dollars
       start      = today, +1 day when L is not 0, +1 more day after 3pm New York
       ship days  = in stock: M + 1 ; made to order: L (0 counts as 1)
       added days = under $251: ship days + 5 (the end of the range the product page shows)
                    $251 and up: ship days + 1 when L is 0, else ship days + 2
       counted in business days: Mon-Fri, not in shop global.exclude_shipping_date
     Occasions: the Delivery Occasion list (data-occ). Each repeats yearly: fixed month/day, nth weekday of a month
     (Mother's Day), or a list of dates (Hanukkah, Diwali). Deliver-by = occasion date - offset days. An occasion runs
     from (deliver-by - show days) to deliver-by; when two overlap, the one with the earliest deliver-by is shown.
     Quick Ship: a variant in stock, or the latest date within 7 days of today. */
  var skip = [];
  try { skip = JSON.parse(root.getAttribute('data-skip') || '[]') || []; } catch (e) { skip = []; }
  var occList = [];
  try { occList = JSON.parse(root.getAttribute('data-occ') || '[]') || []; } catch (e) { occList = []; }
  function ymd(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function nyNow() {
    try { return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' })); } catch (e) { return new Date(); }
  }
  function isBiz(d) { var w = d.getDay(); return w !== 0 && w !== 6 && skip.indexOf(ymd(d)) === -1; }
  function addBiz(d, n) { var x = new Date(d.getTime()); while (n > 0) { x.setDate(x.getDate() + 1); if (isBiz(x)) n--; } return x; }
  function day0(d) { var x = new Date(d.getTime()); x.setHours(0, 0, 0, 0); return x; }
  var now = nyNow();
  var today = day0(now);
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function latestDelivery(card) {
    var q = parseInt(card.getAttribute('data-dq'), 10) || 0;
    var m = parseInt(card.getAttribute('data-dm'), 10); if (isNaN(m)) m = 2;
    var l = parseInt(card.getAttribute('data-dl'), 10); if (isNaN(l)) l = 30;
    var price = parseFloat(card.getAttribute('data-dp')) || 0;
    var start = new Date(today.getTime());
    start.setDate(start.getDate() + (l === 0 ? 0 : 1) + (now.getHours() > 15 ? 1 : 0));
    var ship = q >= 1 ? m + 1 : (l === 0 ? 1 : l);
    var add = price < 251 ? ship + 5 : (l === 0 ? ship + 1 : ship + 2);
    var d = addBiz(start, add);
    while (skip.indexOf(ymd(new Date(d.getTime() + 86400000))) !== -1) d.setDate(d.getDate() + 1); // as the product page: a closed day right after pushes the date
    return d;
  }

  // this year's (or next year's) deliver-by date for one occasion
  function occDate(o, year) {
    if (o.r === 'fixed' && o.m && o.d) return new Date(year, o.m - 1, o.d);
    if (o.r === 'nth_weekday' && o.m && o.k) {
      var first = new Date(year, o.m - 1, 1);
      var shift = ((o.w || 0) - first.getDay() + 7) % 7;
      var x = new Date(year, o.m - 1, 1 + shift + (o.k - 1) * 7);
      return x.getMonth() === o.m - 1 ? x : null;
    }
    if (o.r === 'dated' && o.ds) {
      for (var i = 0; i < o.ds.length; i++) { var p = o.ds[i].split('-'); if (+p[0] === year) return new Date(+p[0], +p[1] - 1, +p[2]); }
    }
    return null;
  }
  var occ = null; // { name, tag, by }
  for (var oi = 0; oi < occList.length; oi++) {
    var o = occList[oi];
    for (var yy = today.getFullYear(); yy <= today.getFullYear() + 1; yy++) {
      var od = occDate(o, yy);
      if (!od) continue;
      var by = new Date(od.getTime()); by.setDate(by.getDate() - (o.o || 0));
      var from = new Date(by.getTime()); from.setDate(from.getDate() - (o.s || 30));
      if (today >= from && today <= by && (!occ || by < occ.by)) occ = { name: o.n, tag: o.t || ('By ' + o.n), by: by };
    }
  }
  // nothing can arrive by the deadline any more (fastest possible: in stock, ships same day, $251+): no occasion toggle
  if (occ) {
    var fastest = addBiz(new Date(today.getTime() + (now.getHours() > 15 ? 86400000 : 0)), 2);
    if (fastest > new Date(occ.by.getTime() + 86399000)) occ = null;
  }
  var quickBy = new Date(today.getTime()); quickBy.setDate(quickBy.getDate() + 7);
  var fastMode = ''; // '' | 'occ' | 'quick'

  // show and fill the occasion toggles
  (function () {
    var els = root.querySelectorAll('[data-tsl-occ-only]');
    for (var i = 0; i < els.length; i++) els[i].hidden = !occ;
    if (!occ) return;
    var labels = root.querySelectorAll('.tsl-occ-label');
    for (var j = 0; j < labels.length; j++) labels[j].textContent = occ.tag;
    var dates = root.querySelectorAll('.tsl-occ-date');
    for (var k = 0; k < dates.length; k++) dates[k].textContent = 'Delivered by ' + MONTHS[occ.by.getMonth()] + ' ' + occ.by.getDate();
    var btns = root.querySelectorAll('[data-tsl-fast="occ"]');
    for (var b = 0; b < btns.length; b++) btns[b].title = 'Pieces delivered by ' + MONTHS[occ.by.getMonth()] + ' ' + occ.by.getDate();
    root.classList.add('has-occ');
  })();

  function markFast(card) {
    if (card.__tslFast) return;
    card.__tslFast = true;
    var d = latestDelivery(card);
    card.__tslArrive = d;
    // as the product page: the range end must be before the deadline (under $251); the single date may fall on it
    var under = (parseFloat(card.getAttribute('data-dp')) || 0) < 251;
    if (occ && (under ? d < occ.by : d <= occ.by)) card.classList.add('is-occ');
    // Quick Ship: in stock, or delivered within 7 days
    if (card.hasAttribute('data-ds') || d <= quickBy) card.classList.add('is-quick');
    tagCard(card);
  }
  // the truck tag: the occasion while one is running, otherwise Quick ship; with a toggle on, that toggle's words
  function tagCard(card) {
    var useOcc = fastMode === 'occ' || (fastMode === '' && !!occ);
    var on = useOcc ? card.classList.contains('is-occ') : card.classList.contains('is-quick');
    card.classList.toggle('is-fast', on);
    if (!on) return;
    var d = card.__tslArrive;
    var t = card.querySelector('.tsl-ship__t'); if (t) t.textContent = useOcc ? occ.tag : 'Quick ship';
    var s = card.querySelector('.tsl-ship'); if (s && d) s.setAttribute('title', 'Arrives by ' + MONTHS[d.getMonth()] + ' ' + d.getDate());
  }

  function applyFast() {
    var cards = grid.querySelectorAll('.tsl-card');
    var shown = 0;
    var need = fastMode === 'occ' ? 'is-occ' : fastMode === 'quick' ? 'is-quick' : '';
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].__tslFast) tagCard(cards[i]);
      var hide = need !== '' && !cards[i].classList.contains(need);
      // the delivery request replaces the tag filter, so the page's own tag filters (Lab grown, shapes) are checked here
      if (!hide && need !== '' && keepTags.length) {
        var tg = cards[i].getAttribute('data-tg') || '';
        hide = !keepTags.some(function (t) { return tg.indexOf(' ' + t + ' ') > -1; });
      }
      cards[i].classList.toggle('is-hidden', hide);
      if (!hide && !cards[i].classList.contains('is-dup')) shown++;
    }
    var extras = grid.querySelectorAll('.tsl-story, .tsl-promo');
    for (var k = 0; k < extras.length; k++) extras[k].style.display = need ? 'none' : '';
    root.classList.toggle('is-empty', need !== '' && shown === 0 && !nextUrl);
    if (countEl) countEl.textContent = !need ? totalText : (shown === 0 && nextUrl ? 'Finding pieces' : shown + (nextUrl ? '+' : '') + ' pieces');
    var ab = root.querySelector('[data-tsl-apply]');
    if (ab) { if (!ab.__srv) ab.__srv = ab.textContent; ab.textContent = !need ? ab.__srv : (shown === 0 && nextUrl ? 'Finding pieces' : 'Show ' + shown + (nextUrl ? '+' : '') + ' results'); }
  }
  // the toggles sit in the floating bar and again at the top of the filter drawer; one can be on at a time
  var fastBtns = root.querySelectorAll('[data-tsl-fast]');
  /* Server-side first: every product carries a delivery tag (ts-dlv-bd-N = business days to the latest delivery
     date, ts-dlv-instock = a variant in stock; kept up to date by a daily job). A toggle asks Shopify for the tags that
     can still make it, so only those products come back, already paged. Then the exact check above (is-occ / is-quick)
     runs on what arrives. Turning the toggle off puts the original list back. */
  function bizUntil(by) { // business days from the ship-day start to a date (inclusive)
    var n = 0, x = new Date(today.getTime());
    if (now.getHours() > 15) x.setDate(x.getDate() + 1);
    while (n < 80) { var y = addBiz(x, 1); if (y > by) break; x = y; n++; }
    return n;
  }
  function dlvTags(mode) {
    var max = mode === 'occ' && occ ? bizUntil(occ.by) : bizUntil(quickBy);
    var t = [];
    for (var n = 0; n <= max + 1; n++) t.push('ts-dlv-bd-' + n); // +1: the tag rounds the first (calendar) day up
    if (mode === 'quick') t.push('ts-dlv-instock');
    return t;
  }
  // tag filters already on the page (Lab grown, shapes); the delivery toggles send their own tag values instead
  var keepTags = new URLSearchParams(location.search).getAll('filter.p.tag').filter(function (t) { return t.indexOf('ts-dlv-') !== 0; });
  var saved = null; // the unfiltered list while a toggle is on
  var swapSeq = 0;
  function swapList(mode) {
    var seq = ++swapSeq;
    if (!saved) saved = { kids: Array.prototype.slice.call(grid.children), next: nextUrl };
    if (!mode) {
      grid.innerHTML = '';
      saved.kids.forEach(function (li) { grid.appendChild(li); });
      nextUrl = saved.next; saved = null;
      if (more) more.hidden = !nextUrl;
      applyFast();
      return;
    }
    var form = root.querySelector('[data-tsl-form]');
    var url = new URL((form && form.getAttribute('action')) || location.pathname, location.origin);
    new URLSearchParams(location.search).forEach(function (v, k) { if (k !== 'page' && k !== 'filter.p.tag') url.searchParams.append(k, v); });
    dlvTags(mode).forEach(function (t) { url.searchParams.append('filter.p.tag', t); });
    url.searchParams.set('section_id', sectionId);
    root.classList.add('is-loading');
    if (countEl) countEl.textContent = 'Finding pieces';
    fetch(pv(url.pathname + url.search), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (seq !== swapSeq) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('[data-tsl-grid]');
      grid.innerHTML = '';
      if (newGrid) Array.prototype.slice.call(newGrid.children).forEach(function (li) { if (li.classList.contains('tsl-card')) grid.appendChild(li); });
      var nm = doc.querySelector('[data-tsl-next]');
      nextUrl = nm ? nm.getAttribute('data-tsl-next') : '';
      if (more) more.hidden = !nextUrl;
      if (famSeen) famSeen = {};
      initCards();
      if (window._swat && typeof window._swat.initializeActionButtons === 'function') { try { window._swat.initializeActionButtons('.tsl-grid'); } catch (e) {} }
    }).catch(function () {}).then(function () {
      if (seq !== swapSeq) return;
      root.classList.remove('is-loading');
      applyFast();
      if (nextUrl && near()) maybeLoad();
    });
  }
  function setMode(mode) {
    fastMode = mode;
    for (var b = 0; b < fastBtns.length; b++) fastBtns[b].setAttribute('aria-pressed', String(fastBtns[b].getAttribute('data-tsl-fast') === mode));
    // until the products carry their delivery tags, fall back to checking the loaded pieces
    if (root.hasAttribute('data-dlv-srv')) swapList(mode);
    else { applyFast(); if (mode) maybeLoad(); }
  }
  for (var fb = 0; fb < fastBtns.length; fb++) {
    fastBtns[fb].addEventListener('click', function (e) {
      e.preventDefault();
      var mode = this.getAttribute('data-tsl-fast');
      setMode(fastMode === mode ? '' : mode);
    });
  }

  /* when this page is a theme preview, keep follow-up requests on the same preview theme */
  function pv(url) {
    var t = window.Shopify && window.Shopify.theme;
    if (!t || t.role === 'main' || !t.id || url.indexOf('preview_theme_id=') > -1) return url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'preview_theme_id=' + t.id;
  }

  /* ---------- photo state per tile: committed photo + hover previews ---------- */
  function el(tag, cls, attrs) { var e = document.createElement(tag); if (cls) e.className = cls; if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]); return e; }
  /* photo store files are .jpg or .png (the product page tries both) */
  var pngHosts = {};
  function setSrc(img, src) {
    if (pngHosts[src]) src = pngHosts[src];
    if (img.__keepLazy) img.setAttribute('loading', 'lazy'); else img.removeAttribute('loading');
    img.onerror = function () {
      var cur = img.getAttribute('src') || '';
      if (/-1\.jpg$/i.test(cur)) { var png = cur.replace(/\.jpg$/i, '.png'); pngHosts[cur] = png; img.src = png; }
    };
    img.src = src;
  }
  function state(card) {
    if (card.__st) return card.__st;
    var img = card.querySelector('.tsl-main');
    if (!img) {
      // the video tile has no photo: add one so stone / metal picks can show their photo
      var media = card.querySelector('.tsl-media');
      if (media) { img = el('img', 'tsl-main tsl-main--added', { alt: '' }); media.insertBefore(img, media.querySelector('.tsl-fade')); }
    }
    var mt = {};
    try { mt = JSON.parse(card.getAttribute('data-mt') || '{}') || {}; } catch (e) { mt = {}; }
    cardfixMt(mt);
    card.__st = { img: img, src: img ? img.currentSrc || img.src : '', srcset: img ? img.getAttribute('srcset') : null, mt: mt, metal: null, base: card.querySelector('a.tsl-info') ? card.querySelector('a.tsl-info').getAttribute('href') : '', vid: !!card.querySelector('video.tsl-video') };
    card.__st.orig = { src: card.__st.src, srcset: card.__st.srcset, mt: mt, vid: card.__st.vid };
    return card.__st;
  }
  function show(card, src) {
    var st = state(card);
    if (!st.img || !src) return;
    st.img.removeAttribute('srcset');
    card.classList.add('is-imgshow');
    setSrc(st.img, src);
  }
  function preview(card, src) { if (!src) return; card.classList.add('is-previewing'); show(card, src); }
  function endPreview(card) {
    var st = state(card);
    card.classList.remove('is-previewing');
    if (!st.img) return;
    if (!st.src) { card.classList.remove('is-imgshow'); return; }
    if (st.vid) card.classList.remove('is-imgshow');
    if (st.srcset && st.img.src !== st.src) { st.img.src = st.src; st.img.setAttribute('srcset', st.srcset); }
    else setSrc(st.img, st.src);
  }
  function commit(card, src) { var st = state(card); st.src = src; st.srcset = null; st.vid = false; show(card, src); }
  function setSub(card, metal, stone) {
    var el2 = card.querySelector('.tsl-info__sub');
    if (!el2) return;
    if (metal != null) el2.setAttribute('data-metal', metal);
    if (stone != null) el2.setAttribute('data-stone', stone);
    var m = el2.getAttribute('data-metal') || '', g = el2.getAttribute('data-stone') || '';
    el2.textContent = m && g ? m + ' · ' + g : (m || g);
  }
  function setLinks(card, url) { card.querySelectorAll('a.tsl-media, a.tsl-info').forEach(function (a) { a.href = url; }); }

  /* Products whose photos are kept in Shopify and named by SKU: a metal entry carries "h", that variant's
     on-model (else side) photo. Once the metal is picked it becomes the tile's hover photo; a metal without "h"
     puts the tile's own hover photo back. Entries without "h" on a tile that never had one: nothing changes. */
  var cardfix = (function () {
    try {
      var q = new URLSearchParams(location.search).get('cardfix');
      if (q === '1') { try { sessionStorage.setItem('ts_cardfix', '1'); } catch (e) {} return true; }
      if (q === '0') { try { sessionStorage.removeItem('ts_cardfix'); } catch (e) {} return false; }
      return sessionStorage.getItem('ts_cardfix') === '1';
    } catch (e) { return /[?&]cardfix=1(&|$)/.test(location.search || ''); }
  })();
  /* switched off (snippets/ts-cardfix-flag.liquid = 0) the Shopify photo of a metal comes as "su" and is used
     only for ?cardfix=1 visitors; otherwise "su" / "h" are ignored and the tile works exactly as before */
  function cardfixMt(mt) {
    if (!mt) return mt;
    for (var k in mt) {
      var m = mt[k]; if (!m || typeof m !== 'object') continue;
      if (cardfix && m.su) { m.u = m.su; }
      else if (!cardfix && m.su && m.h) { delete m.h; }
    }
    return mt;
  }
  /* default hover photo of a SKU-photo product (data-ts-hov), applied the way detectModel does */
  function cardfixHover(card) {
    var u = card.getAttribute('data-ts-hov');
    if (!cardfix || !u || card.__tslCand === 'ts') return;
    card.__tslCand = 'ts';   // the white-background test below is not needed for this tile
    var media = card.querySelector('.tsl-media'); if (!media) return;
    var alt = card.querySelector('.tsl-alt');
    if (!alt) { alt = el('img', 'tsl-alt', { alt: '', loading: 'lazy' }); media.insertBefore(alt, media.querySelector('.tsl-fade')); }
    alt.removeAttribute('srcset'); alt.removeAttribute('sizes');
    alt.src = u;
    // a plain hover photo: no is-model / has-model, so the tile keeps its colours on hover
    card.classList.add('has-alt');
  }
  function metalHover(card, m) {
    var media = card.querySelector('.tsl-media'); if (!media) return;
    var alt = card.querySelector('.tsl-alt');
    if (m && m.h) {
      if (card.__hov) return;   // another stone is shown: its hover stays off, as before
      if (!card.__tslAltOrig) {
        card.__tslAltOrig = { had: !!alt, src: alt ? alt.getAttribute('src') : null, srcset: alt ? alt.getAttribute('srcset') : null, sizes: alt ? alt.getAttribute('sizes') : null,
          model: alt ? alt.classList.contains('is-model') : false, hasAlt: card.classList.contains('has-alt'), hasModel: card.classList.contains('has-model') };
      }
      if (!alt) { alt = el('img', 'tsl-alt', { alt: '', loading: 'lazy' }); media.insertBefore(alt, media.querySelector('.tsl-fade')); }
      alt.removeAttribute('srcset'); alt.removeAttribute('sizes');
      alt.src = m.h;
      // shown on hover of a picked metal (ts-pickhov, see ts-lux-collection.css) without the dark model-tile styling
      alt.classList.remove('is-model');
      card.classList.remove('has-model');
      card.classList.add('has-alt', 'ts-pickhov');
    } else if (card.__tslAltOrig) {
      var o = card.__tslAltOrig; card.__tslAltOrig = null;
      if (!o.had) { if (alt) alt.remove(); }
      else if (alt) {
        if (o.src != null) alt.setAttribute('src', o.src);
        if (o.srcset != null) alt.setAttribute('srcset', o.srcset); else alt.removeAttribute('srcset');
        if (o.sizes != null) alt.setAttribute('sizes', o.sizes); else alt.removeAttribute('sizes');
        alt.classList.toggle('is-model', o.model);
      }
      card.classList.toggle('has-alt', o.hasAlt);
      card.classList.toggle('has-model', o.hasModel);
      card.classList.remove('ts-pickhov');
    }
  }

  /* metal dots: hover previews that metal, click keeps it */
  function setupMetals(card) {
    var btns = card.querySelectorAll('.tsl-mt');
    if (!btns.length) return;
    btns.forEach(function (b) {
      var code = b.getAttribute('data-m');
      var name = (state(card).mt[code] || {}).n || '';
      if (name) { b.setAttribute('aria-label', name); b.title = name; }
      function prev() { var m = state(card).mt[code]; if (m) preview(card, m.u); }
      b.addEventListener('mouseenter', prev);
      b.addEventListener('focus', prev);
      b.addEventListener('mouseleave', function () { endPreview(card); });
      b.addEventListener('blur', function () { endPreview(card); });
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        var st = state(card), m = st.mt[code];
        if (!m) return;
        st.metal = code;
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        card.classList.add('is-picked');
        commit(card, m.u);
        metalHover(card, m);
        if (m.n) setSub(card, m.n, null);
        setLinks(card, st.base.split('?')[0] + '?variant=' + m.v);
      });
    });
  }

  /* stone swatches inside the photo: hover previews, click keeps it */
  var cache = {};
  function stonePhoto(card, s) {
    var st = state(card);
    if (st.metal && s.mt && s.mt[st.metal]) return s.mt[st.metal].u;
    return s.m;
  }
  function ctLabel(c) { var n = parseFloat(c); return isNaN(n) ? String(c || '') : String(n); }
  function gemBtn(card, s, i, pick) {
    var b;
    if (card.__tslKind === 'carat') {
      var lab = ctLabel(s.c) + ' ct';
      b = el('button', 'tsl-ct', { type: 'button', 'aria-label': lab, title: lab + ' · ' + s.p, 'aria-pressed': i === card.__tslPick ? 'true' : 'false' });
      b.textContent = ctLabel(s.c);
    } else {
      b = el('button', 'tsl-gem', { type: 'button', 'aria-label': s.n, title: s.n, 'aria-pressed': i === card.__tslPick ? 'true' : 'false' });
      var dot = el('span'); dot.style.backgroundImage = 'url("' + s.i + '")';
      b.appendChild(dot);
    }
    b.addEventListener('mouseenter', function () { preview(card, stonePhoto(card, s)); if (card.__tslPriceTo) card.__tslPriceTo(s); });
    b.addEventListener('focus', function () { preview(card, stonePhoto(card, s)); if (card.__tslPriceTo) card.__tslPriceTo(s); });
    b.addEventListener('mouseleave', function () { endPreview(card); if (card.__tslPriceBack) card.__tslPriceBack(); });
    b.addEventListener('blur', function () { endPreview(card); if (card.__tslPriceBack) card.__tslPriceBack(); });
    b.addEventListener('click', function (ev) { ev.preventDefault(); pick(i); });
    return b;
  }
  function buildSwatches(card, list, kind) {
    if (!list || list.length < 2) return;
    card.__tslKind = kind === 'carat' ? 'carat' : 'gem';
    var isCt = card.__tslKind === 'carat';
    var chips = isCt && root.hasAttribute('data-ctchips');
    // a size can be listed twice (carat_listing_1 and _2): keep one per product
    var seenU = {};
    list = list.filter(function (x) { if (!x || seenU[x.u]) return false; seenU[x.u] = 1; return true; });
    if (list.length < 2) return;
    var self = list[0];
    if (isCt) list = list.slice().sort(function (a, b) { return (parseFloat(a.c) || 0) - (parseFloat(b.c) || 0); });
    var maxShort = chips ? 6 : 4;
    card.__tslList = list;
    card.__tslPick = Math.max(0, list.indexOf(self));
    var row = card.querySelector('.tsl-sw__stones');
    var panelList = card.querySelector('.tsl-panel__list');
    var panelName = card.querySelector('.tsl-panel__name');
    var title = card.querySelector('.tsl-info__title');
    var price = card.querySelector('.tsl-info__price');
    var sub = card.querySelector('.tsl-info__sub');
    var orig = { price: price ? price.innerHTML : '' };

    function pick(i) {
      var s = list[i], st = state(card), o = st.orig;
      card.__tslPick = i;
      card.classList.remove('is-browsing', 'is-previewing');
      if (s === self && !st.metal) {
        // back to the stone the tile loaded with: its own photo, hover shot, video and photo gallery
        st.mt = o.mt; st.src = o.src; st.srcset = o.srcset; st.vid = o.vid;
        card.classList.remove('is-picked');
        if (card.__hov) { card.__hov.forEach(function (c) { card.classList.add(c); }); card.__hov = null; }
        if (st.img) { st.img.style.opacity = ''; if (o.srcset) { st.img.src = o.src; st.img.setAttribute('srcset', o.srcset); } else if (o.src) setSrc(st.img, o.src); }
        if (o.vid || !o.src) card.classList.remove('is-imgshow');
        setVideo(card, null);
      } else {
        card.classList.add('is-picked');
        // the hover / model shot belongs to the first stone: switch it off while another stone is shown
        if (card.__tslAltOrig && !card.__hov) metalHover(card, null);
        if (!card.__hov) { card.__hov = ['has-alt', 'has-model'].filter(function (c) { return card.classList.contains(c); }); card.classList.remove('has-alt', 'has-model'); }
        if (s.mt) st.mt = s.mt;
        commit(card, stonePhoto(card, s));
        // that stone's own video, when it has one and no metal is chosen
        if (!st.metal && s.v && setVideo(card, s.v)) { st.vid = true; card.classList.remove('is-imgshow'); }
        else setVideo(card, null, true);
      }
      // swipe / arrows step through the chosen stone's photos
      if (card.__galSet) card.__galSet(s === self ? null : (s.g || []));
      if (title) title.textContent = s.t;
      if (price) { if (s === self) price.innerHTML = orig.price; else price.textContent = s.p; }
      setSub(card, null, s.n);
      if (panelName) panelName.textContent = isCt ? ctLabel(s.c) + ' ct · ' + s.p : s.n;
      st.base = s.u;
      var m = st.metal && st.mt[st.metal];
      setLinks(card, m ? s.u + '?variant=' + m.v : s.u);
      render();
    }
    // hovering a stone dot or carat chip shows that piece's price; leaving goes back to the chosen one
    card.__tslPriceTo = function (x) { if (price && x.p) price.textContent = x.p; };
    card.__tslPriceBack = function () { var cur = list[card.__tslPick]; if (!price || !cur) return; if (cur === self) price.innerHTML = orig.price; else price.textContent = cur.p; };
    if (chips) card.classList.add('has-ct');
    if (isCt && !chips) {
      // sizes sold as separate products (studs): one quiet line, sizes are chosen on the product page
      var lo = ctLabel(list[0].c), hi = ctLabel(list[list.length - 1].c);
      row.innerHTML = '';
      var note = el('span', 'tsl-sw__note');
      note.textContent = lo + ' to ' + hi + ' ct · ' + list.length + ' sizes';
      row.appendChild(note);
      var sz = card.querySelector('.tsl-sw__sizes'); if (sz) sz.remove();
      return;
    }
    function render() {
      row.innerHTML = '';
      var shortList = [];
      for (var k0 = 0; k0 < Math.min(maxShort, list.length); k0++) shortList.push(k0);
      if (card.__tslPick >= maxShort) shortList[maxShort - 1] = card.__tslPick;
      shortList.forEach(function (k) { row.appendChild(gemBtn(card, list[k], k, pick)); });
      if (isCt) { var u = el('span', 'tsl-ct-u'); u.textContent = 'ct'; row.appendChild(u); }
      if (list.length > maxShort) {
        var more = el('button', 'tsl-sw__more', { type: 'button', 'aria-label': 'Show all ' + list.length + (isCt ? ' sizes' : ' stones'), 'aria-expanded': 'false' });
        more.textContent = '+' + (list.length - maxShort);
        more.addEventListener('click', function (ev) { ev.preventDefault(); card.classList.add('is-open'); more.setAttribute('aria-expanded', 'true'); var f = panelList.querySelector('button'); if (f) f.focus(); });
        row.appendChild(more);
      }
      panelList.innerHTML = '';
      list.forEach(function (s, k) { panelList.appendChild(gemBtn(card, s, k, pick)); });
      var cur = list[card.__tslPick];
      if (panelName) panelName.textContent = isCt ? ctLabel(cur.c) + ' ct · ' + cur.p : cur.n;
    }
    render();
    var x = card.querySelector('.tsl-panel__x');
    if (x) x.addEventListener('click', function () { card.classList.remove('is-open'); });
    card.addEventListener('mouseleave', function () { card.classList.remove('is-open'); });
  }
  function loadSwatches(card) {
    var url = card.getAttribute('data-sw');
    if (!url || card.__tslSw) return;
    card.__tslSw = true;
    var p = cache[url] || (cache[url] = fetch(pv(url), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }));
    p.then(function (d) {
      if (!d || !d.s) return;
      d.s.forEach(function (x) { if (x && x.mt) cardfixMt(x.mt); });
      if (d.k !== 'carat' && card.hasAttribute('data-nogem')) return; // single-stone page: metals only
      buildSwatches(card, d.s, d.k);
    });
  }

  /* ---------- model photo on hover: first non-white-background photo (same test as the product page) ---------- */
  function isModelShot(url, cb) {
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var c = document.createElement('canvas'); c.width = c.height = 24;
        var x = c.getContext('2d'); x.fillStyle = '#fff'; x.fillRect(0, 0, 24, 24); x.drawImage(im, 0, 0, 24, 24);
        var d = x.getImageData(0, 0, 24, 24).data, w = 0, n = 0;
        for (var y = 0; y < 24; y++) for (var xx = 0; xx < 24; xx++) {
          if (y > 1 && y < 22 && xx > 1 && xx < 22) continue;
          var q = (y * 24 + xx) * 4; if ((d[q] + d[q + 1] + d[q + 2]) / 3 > 225) w++; n++;
        }
        cb(w / n < 0.45);
      } catch (e) { cb(false); }
    };
    im.onerror = function () { cb(false); };
    im.src = url.replace(/([?&])width=\d+/, '$1width=48');
  }
  function detectModel(card) {
    var raw = card.getAttribute('data-cand');
    if (!raw || card.__tslCand) return;
    card.__tslCand = true;
    var list = raw.split('|').filter(Boolean), k = 0;
    (function next() {
      if (k >= list.length) return;
      var u = list[k++];
      isModelShot(u, function (yes) {
        if (!yes) return next();
        var media = card.querySelector('.tsl-media');
        var alt = card.querySelector('.tsl-alt');
        if (!alt) { alt = el('img', 'tsl-alt', { alt: '', loading: 'lazy' }); media.insertBefore(alt, media.querySelector('.tsl-fade')); }
        alt.removeAttribute('srcset'); alt.removeAttribute('sizes');
        alt.src = u;
        alt.classList.add('is-model');
        card.classList.add('has-alt', 'has-model');
      });
    })();
  }

  /* ---------- the one video tile: play only while on screen ---------- */
  /* white-background product videos sit on the tile gradient like the photos do (styled videos stay as they are) */
  function checkWhiteVideo(card, v) {
    v.addEventListener('loadeddata', function once() {
      v.removeEventListener('loadeddata', once);
      try {
        var w = v.videoWidth, h = v.videoHeight; if (!w || !h) return;
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var x = c.getContext('2d'); x.drawImage(v, 0, 0, w, h);
        var pts = [[4, 4], [w - 5, 4], [4, h - 5], [w - 5, h - 5], [w >> 1, 4]], white = true;
        for (var i = 0; i < pts.length; i++) {
          var d = x.getImageData(pts[i][0], pts[i][1], 1, 1).data;
          if (d[0] < 240 || d[1] < 240 || d[2] < 240) { white = false; break; }
        }
        if (white) card.classList.add('vid-white');
      } catch (e) { /* cross-origin frame: leave the video as it is */ }
    });
  }
  /* stone picks on the video tile: show that stone's video (src) or the tile's own video (null); keepPhoto leaves the photo on top */
  function setVideo(card, src, keepPhoto) {
    var v = card.querySelector('video.tsl-video');
    if (!v) return false;
    if (!v.__own) v.__own = { src: v.getAttribute('data-src'), poster: v.getAttribute('poster') };
    if (keepPhoto) { v.pause(); return false; }
    var want = src || v.__own.src;
    if (v.getAttribute('data-src') !== want) {
      v.setAttribute('data-src', want);
      if (!src) v.setAttribute('poster', v.__own.poster || ''); else v.removeAttribute('poster');
      v.src = want;
    } else if (!v.src) v.src = want;
    var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    return true;
  }
  function setupVideo(card) {
    var v = card.querySelector('video.tsl-video');
    if (!v || v.__tsl) return;
    v.__tsl = true;
    v.crossOrigin = 'anonymous';
    checkWhiteVideo(card, v);
    if (!('IntersectionObserver' in window)) { v.src = v.getAttribute('data-src'); v.play && v.play().catch(function () {}); return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { if (!v.src) v.src = v.getAttribute('data-src'); var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else if (v.src) v.pause();
      });
    }, { rootMargin: '200px 0px' }).observe(v);
  }
  /* sound button on the banner video: videos start muted (browsers only autoplay muted) */
  function soundState(btn, on) {
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
  }
  /* banner video sound button: one video plays sound at a time */
  function setupHeroSound() {
    document.querySelectorAll('.tsl-sound--hero').forEach(function (btn) {
      if (btn.__tsl) return;
      var v = btn.parentNode.querySelector('video.' + btn.getAttribute('data-for'));
      if (!v) return;
      btn.__tsl = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var on = btn.getAttribute('aria-pressed') !== 'true';
        document.querySelectorAll('video').forEach(function (o) { if (o !== v) o.muted = true; });
        document.querySelectorAll('.tsl-sound--hero').forEach(function (o) { if (o !== btn) soundState(o, false); });
        v.muted = !on;
        if (on) { v.volume = 1; var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        soundState(btn, on);
      });
      /* sound goes off once the banner scrolls out of view */
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) {
        es.forEach(function (x) { if (!x.isIntersecting && !v.muted) { v.muted = true; soundState(btn, false); } });
      }).observe(v);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupHeroSound); else setupHeroSound();


  /* ---------- hover arrows: step through every photo of the piece (Louis Vuitton style) ---------- */
  var arrowSvg = function (d) { return '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };
  function setupGallery(card) {
    var own = (card.getAttribute('data-gal') || '').split('|').filter(Boolean).slice(0, 8);
    var gal = own;
    var frame = card.querySelector('.tsl-frame');
    if (!frame) return;
    var built = false;
    /* a stone pick hands over that stone's photos (null = the tile's own) */
    card.__galSet = function (list) {
      gal = (list || own).slice(0, 8);
      idx = 0; browsing = false; card.classList.remove('is-browsing');
      card.classList.toggle('no-gal', gal.length < 2);
      if (gal.length >= 2 && !built) build();
      if (dots) { dots.innerHTML = ''; for (var k = 0; k < gal.length; k++) dots.appendChild(el('i')); mark(); }
    };
    var idx = 0, dots = null, browsing = false;
    var hoverDev = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
    function fname(u) { return String(u || '').split('?')[0].split('/').pop(); }
    /* desktop: hovering already shows the side / model photo, so the arrows start from that photo
       (first click = the next one after it); phones start from the front photo */
    function home() {
      if (!hoverDev || card.classList.contains('is-picked') || !card.classList.contains('has-alt')) return 0;
      var a = card.querySelector('.tsl-alt'); if (!a) return 0;
      var f = fname(a.getAttribute('src') || a.currentSrc);
      for (var g = 0; g < gal.length; g++) if (fname(gal[g]) === f) return g;
      return 0;
    }
    function mark() {
      if (!dots) return;
      for (var d = 0; d < dots.children.length; d++) dots.children[d].classList.toggle('is-on', d === idx);
    }
    function reset() {
      var st = state(card);
      clearTimeout(swapT); if (st.img) st.img.style.opacity = '';
      browsing = false; card.classList.remove('is-browsing'); endPreview(card);
    }
    function go(step) {
      var st = state(card);
      if (gal.length < 2 || !st.img) return;
      var h = home();
      if (!browsing) idx = h;
      idx = (idx + step + gal.length) % gal.length;
      mark();
      if (idx === h) { reset(); return; }
      browsing = true;
      card.classList.add('is-browsing');
      card.classList.add('is-imgshow'); // video tiles: the photo layer covers the video while browsing
      swap(st.img, gal[idx]);
    }
    /* soft crossfade: fade the photo out, change it, fade back in once the new one has loaded */
    var swapT = null;
    function swap(img, src) {
      clearTimeout(swapT);
      img.style.transition = 'opacity .18s ease';
      img.style.opacity = '0';
      swapT = setTimeout(function () {
        var done = false;
        function back() { if (done) return; done = true; img.style.opacity = ''; setTimeout(function () { img.style.transition = ''; }, 220); }
        img.addEventListener('load', back, { once: true });
        img.removeAttribute('srcset');
        setSrc(img, src);
        if (img.complete) back();
        setTimeout(back, 600);
      }, 170);
    }
    if (gal.length < 2) { card.classList.add('no-gal'); return; }
    build();
    function build() {
    built = true;
    ['prev', 'next'].forEach(function (dir) {
      var b = el('button', 'tsl-arw tsl-arw--' + dir, { type: 'button', 'aria-label': dir === 'prev' ? 'Previous photo' : 'Next photo' });
      b.innerHTML = arrowSvg(dir === 'prev' ? 'M14.5 6l-6 6 6 6' : 'M9.5 6l6 6-6 6');
      b.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); go(dir === 'prev' ? -1 : 1); });
      frame.appendChild(b);
    });
    // leaving the tile goes back to its normal photo, so the next visit starts fresh
    if (hoverDev) card.addEventListener('mouseleave', function () { if (browsing) { idx = 0; reset(); } });
    /* phones: swipe the photo left / right to step through the photos; dots show where you are */
    var media = card.querySelector('.tsl-media');
    if (!media || !('ontouchstart' in window)) return;
    dots = el('span', 'tsl-dots', { 'aria-hidden': 'true' });
    for (var k = 0; k < gal.length; k++) dots.appendChild(el('i'));
    frame.appendChild(dots);
    mark();
    var x0 = 0, y0 = 0, swiped = false, tracking = false;
    media.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      tracking = true; swiped = false;
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    media.addEventListener('touchmove', function (e) {
      if (!tracking || swiped) return;
      var dx = e.touches[0].clientX - x0, dy = e.touches[0].clientY - y0;
      if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy) * 1.4) { swiped = true; go(dx < 0 ? 1 : -1); }
      else if (Math.abs(dy) > 20 && Math.abs(dy) > Math.abs(dx)) tracking = false; // page scroll
    }, { passive: true });
    media.addEventListener('touchend', function () { tracking = false; }, { passive: true });
    // a swipe is not a tap: don't open the product
    media.addEventListener('click', function (e) { if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; } }, true);
    }
  }

  /* metal filter (e.g. Blackened Gold) on: every tile switches to that metal's photo, name and link, as if its dot was clicked */
  var filterMetals = (function () {
    var map = { black: 'b', rose: 'r', white: 'w', yellow: 'y', platinum: 'p' }, out = [];
    try {
      new URLSearchParams(location.search).getAll('filter.p.m.custom.metal').forEach(function (v) {
        v = String(v).toLowerCase();
        for (var k in map) if (v.indexOf(k) > -1 && out.indexOf(map[k]) < 0) out.push(map[k]);
      });
    } catch (e) {}
    return out;
  })();
  function applyFilterMetal(card) {
    if (!filterMetals.length || card.__tslFm) return;
    card.__tslFm = true;
    var st = state(card), mt = st.mt;
    // tiles further down keep loading their (new) photo lazily
    if (st.img && card.getBoundingClientRect().top > window.innerHeight * 1.5) st.img.__keepLazy = true;
    for (var i = 0; i < filterMetals.length; i++) {
      var code = filterMetals[i];
      if (!mt[code]) continue;
      var b = card.querySelector('.tsl-mt[data-m="' + code + '"]');
      if (b) b.click();
      else {
        st.metal = code; card.classList.add('is-picked');
        commit(card, mt[code].u); metalHover(card, mt[code]); if (mt[code].n) setSub(card, mt[code].n, null);
        setLinks(card, st.base.split('?')[0] + '?variant=' + mt[code].v);
      }
      break;
    }
    if (st.img) st.img.__keepLazy = false;
  }

  var swObs = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { swObs.unobserve(e.target); loadSwatches(e.target); detectModel(e.target); } });
  }, { rootMargin: '600px 0px' }) : null;
  var famSeen = root.hasAttribute('data-ctchips') ? {} : null;
  function initCards(scope) {
    var cards = (scope || grid).querySelectorAll('.tsl-card');
    for (var i = 0; i < cards.length; i++) {
      var c = cards[i];
      if (c.__tslInit) continue;
      c.__tslInit = true;
      // studs page: every size of a design is its own product; show the design once, sizes become chips
      if (famSeen && c.getAttribute('data-fam')) {
        var fk = c.getAttribute('data-fam');
        if (famSeen[fk]) { c.classList.add('is-dup'); continue; }
        famSeen[fk] = 1;
      }
      markFast(c);
      if (c.hasAttribute('data-sw') || c.hasAttribute('data-cand')) { if (swObs) swObs.observe(c); else { loadSwatches(c); detectModel(c); } }
      cardfixHover(c);
      setupMetals(c);
      applyFilterMetal(c);
      setupVideo(c);
      setupGallery(c);
    }
  }
  initCards();

  /* ---------- load every page automatically (no "View more") ---------- */
  var more = root.querySelector('[data-tsl-next]');
  var nextUrl = more ? more.getAttribute('data-tsl-next') : '';
  var busy = false;
  var sectionId = root.getAttribute('data-section');
  function maybeLoad() {
    if (busy || !nextUrl) return;
    busy = true;
    root.classList.add('is-loading');
    var u = nextUrl + (nextUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
    fetch(pv(u), { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('[data-tsl-grid]');
      var frag = document.createDocumentFragment();
      if (newGrid) Array.prototype.slice.call(newGrid.children).forEach(function (li) { if (li.classList.contains('tsl-card')) frag.appendChild(li); });
      grid.appendChild(frag);
      var nm = doc.querySelector('[data-tsl-next]');
      nextUrl = nm ? nm.getAttribute('data-tsl-next') : '';
      initCards();
      if (window._swat && typeof window._swat.initializeActionButtons === 'function') { try { window._swat.initializeActionButtons('.tsl-grid'); } catch (e) {} }
    }).catch(function () { /* keep the current list; the next scroll tries again */ }).then(function () {
      busy = false;
      root.classList.remove('is-loading');
      if (more) more.hidden = !nextUrl;
      applyFast();
      // keep going while the end of the list is still near the screen (or the toggle is hiding most pieces)
      if (nextUrl && more && near()) maybeLoad();
    });
  }
  function near() { if (!more || more.hidden || !more.offsetParent) return false; var r = more.getBoundingClientRect(); return r.top < window.innerHeight + 1600; }
  if (more) {
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { if (es[0].isIntersecting) maybeLoad(); }, { rootMargin: '1600px 0px' }).observe(more);
    }
    // also on scroll, so a fast scroll past the end of the list (into the reviews / footer) still loads the next page
    var ldTick = false;
    window.addEventListener('scroll', function () {
      if (ldTick || !more || more.hidden) return; ldTick = true;
      requestAnimationFrame(function () { ldTick = false; if (near()) maybeLoad(); });
    }, { passive: true });
  }

  /* ---------- floating Filter & Sort pill: shown while the grid is on screen ---------- */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { root.classList.toggle('is-pill', es[0].isIntersecting); }, { rootMargin: '0px 0px -40% 0px' }).observe(grid);
  } else root.classList.add('is-pill');

  /* ---------- sticky toolbar sits under a sticky header ---------- */
  function headerOffset() {
    var h = document.querySelector('sticky-header') || document.querySelector('.shopify-section-header-sticky');
    var off = 0;
    if (h) { var cs = getComputedStyle(h); if (cs.position === 'sticky' || cs.position === 'fixed') { var r = h.getBoundingClientRect(); if (r.top <= 0 && r.bottom > 0) off = Math.round(r.bottom); } }
    // only write when it changes: a CSS variable on the grid's root restyles every tile
    if (off !== root.__tslOff) { root.__tslOff = off; root.style.setProperty('--tsl-sticky', off + 'px'); }
  }
  headerOffset();
  window.addEventListener('resize', headerOffset);
  var hoTick = false;
  window.addEventListener('scroll', function () { if (hoTick) return; hoTick = true; requestAnimationFrame(function () { hoTick = false; headerOffset(); }); }, { passive: true });

  /* ---------- sort + filter drawer ---------- */
  var sortSel = root.querySelector('[data-tsl-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var u = new URL(location.href);
    u.searchParams.set('sort_by', sortSel.value);
    u.searchParams.delete('page');
    location.href = u.toString();
  });
  var drawer = root.querySelector('.tsl-drawer');
  var lastFocus = null;
  function openDrawer() { drawerDirty = false; lastFocus = document.activeElement; drawer.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; var f = drawer.querySelector('summary, input, button'); if (f) f.focus(); }
  var drawerDirty = false; // something was ticked since the drawer opened
  function closeDrawer() {
    // closing (x, outside, Esc) after changing filters applies them, same as Show results
    if (drawerDirty && form) { drawerDirty = false; if (form.requestSubmit) form.requestSubmit(); else form.submit(); return; }
    drawer.classList.remove('is-open'); document.documentElement.style.overflow = ''; if (lastFocus) lastFocus.focus();
  }
  root.querySelectorAll('[data-tsl-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
  root.querySelectorAll('[data-tsl-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
  /* ---------- cart + search stay reachable while scrolling, and a back-to-top arrow ---------- */
  var qi = root.querySelector('[data-tsl-qicons]');
  var toTop = root.querySelector('[data-tsl-top]');
  function visibleEl(sel) {
    var list = document.querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) { var r = list[i].getBoundingClientRect(); if (r.width > 0 && r.height > 0) return list[i]; }
    return null;
  }
  function syncCount() {
    if (!qi) return;
    var b = document.querySelector('.cart-count-bubble span:not(.visually-hidden)');
    var n = b ? parseInt(b.textContent, 10) || 0 : 0;
    var out = qi.querySelector('[data-tsl-qcount]');
    if (out && out.__n !== n) { out.__n = n; out.textContent = n > 0 ? n : ''; out.hidden = n <= 0; }
  }
  function floatTick() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var hdr = document.querySelector('sticky-header') || document.querySelector('header');
    var hb = hdr ? hdr.getBoundingClientRect() : { bottom: 0, height: 0 };
    if (qi) {
      // only when the site header is pinned but its own cart icon is hidden
      var need = y > 200 && hb.bottom > 0 && !visibleEl('.header__icon--cart');
      if (qi.__on !== need) { qi.__on = need; qi.classList.toggle('is-on', need); }
      if (need) {
        var qt = Math.max(0, hb.top) + 'px', qh = hb.height + 'px';
        if (qi.style.top !== qt) qi.style.top = qt;
        if (qi.style.height !== qh) qi.style.height = qh;
        syncCount();
      }
    }
    if (toTop) { var tt = y > window.innerHeight * 1.5; if (toTop.__on !== tt) { toTop.__on = tt; toTop.classList.toggle('is-on', tt); } }
  }
  if (qi) {
    qi.querySelector('[data-tsl-qcart]').addEventListener('click', function (ev) {
      var orig = document.querySelector('sticky-header .header__icon--cart') || document.querySelector('.header__icon--cart');
      if (orig) { ev.preventDefault(); orig.click(); }
    });
  }
  if (toTop) toTop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  var ftTick = false;
  window.addEventListener('scroll', function () { if (ftTick) return; ftTick = true; requestAnimationFrame(function () { ftTick = false; floatTick(); }); }, { passive: true });
  floatTick();

  var form = root.querySelector('[data-tsl-form]');
  /* live drawer: each tick asks Shopify for the matching count; the button shows it and the
     filter groups are redrawn, so options with no matching pieces drop out (ticked ones stay) */
  var liveSeq = 0, liveT = null;
  function drawerParams() {
    var q = new URLSearchParams();
    new FormData(form).forEach(function (v, k) {
      if (k === 'sort_by' || v === '') return;
      q.append(k, v);
    });
    return q;
  }
  function fgKey(d) { var k = d.querySelector('summary'); if (!k) return ''; var sp = k.querySelector('span'); var n = (sp || k).firstChild; return n ? n.textContent.trim() : ''; }
  function refreshDrawer() {
    var seq = ++liveSeq;
    var q = drawerParams();
    q.set('section_id', sectionId);
    var ab = form.querySelector('[data-tsl-apply]');
    if (ab) ab.classList.add('is-busy');
    fetch(pv((form.getAttribute('action') || location.pathname) + '?' + q.toString()), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (seq !== liveSeq || !html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var body = form.querySelector('.tsl-drawer__body');
        var nb = doc.querySelector('[data-tsl-form] .tsl-drawer__body');
        if (!body || !nb) return;
        var openNow = {};
        body.querySelectorAll('details.tsl-fg:not(.tsl-sortm)').forEach(function (d) { openNow[fgKey(d)] = d.open; });
        var top = body.scrollTop;
        var olds = body.querySelectorAll('details.tsl-fg:not(.tsl-sortm)');
        var anchor = olds.length ? olds[0] : null;
        var frag = document.createDocumentFragment();
        nb.querySelectorAll('details.tsl-fg:not(.tsl-sortm)').forEach(function (d) {
          var key = fgKey(d);
          if (Object.prototype.hasOwnProperty.call(openNow, key)) d.open = openNow[key];
          frag.appendChild(document.importNode(d, true));
        });
        if (anchor) anchor.parentNode.insertBefore(frag, anchor); else body.appendChild(frag);
        olds.forEach(function (d) { d.remove(); });
        body.scrollTop = top;
        var nab = doc.querySelector('[data-tsl-apply]');
        if (ab && nab) { ab.__srv = nab.textContent; if (!fastMode) ab.textContent = nab.textContent; }
      })
      .catch(function () {})
      .then(function () { if (seq === liveSeq && ab) ab.classList.remove('is-busy'); });
  }
  if (form) form.addEventListener('change', function (e) {
    var t = e.target;
    drawerDirty = true;
    if (!t || t.name === 'sort_by') return;
    clearTimeout(liveT);
    liveT = setTimeout(refreshDrawer, 200);
  });
  if (form) form.addEventListener('submit', function () {
    // one sort_by value: a checked radio (mobile) wins over the hidden copy
    var r = form.querySelector('input[type="radio"][name="sort_by"]:checked');
    var h = form.querySelector('[data-tsl-sort-hidden]');
    if (r && h) { h.value = r.value; form.querySelectorAll('input[type="radio"][name="sort_by"]').forEach(function (x) { x.disabled = true; }); }
    // empty price boxes would send empty params
    form.querySelectorAll('.tsl-price input').forEach(function (i) { if (i.value === '') i.disabled = true; });
  });
})();
